<template>
	<div id="Smart0">
		<Header :navbg='true'></Header>
		<div class="spot-wrap">
			<img class="iframe-image" src="../../../assets/images/smart0/smart0.png" v-if="browser=='Edge'">
			<iframe ref="iframe" src="https://app.modaiyun.com/damf/rendering-viewer/pano/LxXcz7uWsx?isRoaming=true"
				frameborder="0" style="width: 100%;height: 100%;" v-else></iframe>
			<div class="btn-wrap">
				<!-- <van-button @click="followTap" round color="">关注订制</van-button> -->
				<wxLaunchWeapp username="gh_327d9cf99066" path="housePage/pages/house-intention/house-intention.html" 
				imgName="smart0-xiaochengxucode"
				:notwxbtnStyle="notwxbtnStyle" wxbtnStyle="{font-size: 12px;
									line-height: 32px;
									text-align: center;
									width:186px;
									height:32px;
									border: 1px solid #000;
									border-radius:16px;
									background:#FFFFFF;
									color:#000;}" btnText="关注订制">
				</wxLaunchWeapp>
			</div>
		</div>
		<div class="spot-wrap section-spot" :id="'section'+index" v-for="(item,index) in lightspotList" :key="index">
			<img class="spot-img" :src="item.image" alt="">
			<div class="btn-wrap">
				<!-- <van-button @click="followTap" round color="#393C41" plain>关注订制</van-button> -->
				<wxLaunchWeapp username="gh_327d9cf99066" path="housePage/pages/house-intention/house-intention.html" 
						imgName="smart0-xiaochengxucode"
						:notwxbtnStyle="notwxbtnStyle" wxbtnStyle="{font-size: 12px;
									line-height: 32px;
									text-align: center;
									width:186px;
									height:32px;
									border: 1px solid #000;
									border-radius:16px;
									background:#FFFFFF;
									color:#000;}" btnText="关注订制">
				</wxLaunchWeapp>
			</div>
		</div>
		<Footer />
	</div>
</template>
<script>
	import utils from '@/common/utils'
	import Header from '@/components/head2022'
	import Footer from '@/components/foot2022'
	import wxLaunchWeapp from '@/components/wx-launch-weapp'
	import {
		myBrowser
	} from '@/common/app.js';
	export default {
		components: {
			Header,
			Footer,
			wxLaunchWeapp
		},
		data() {
			return {
				browser: '',
				lightspotList: [{
						image: require('../../../assets/images/smart0/green-house.jpg'),
					},
					{
						image: require('../../../assets/images/smart0/constant-house.jpg'),

					},
					{
						image: require('../../../assets/images/smart0/ecology-house.jpg'),
					},
					{
						image: require('../../../assets/images/smart0/green-travel.jpg'),
					},
					{
						image: require('../../../assets/images/smart0/future-house.jpg'),
					}
				],
				notwxbtnStyle:{
					fontSize: "12px",
					lineHeight: "32px",
					textAlign: "center",
					width: "186px",
					height: "32px",
					border: "1px solid #000000",
					borderRadius: "16px",
					background:"#FFFFFF",
					color:"#000000",
				},
			}
		},
		created() {
			this.browser = myBrowser();
		},
		methods: {
			// followTap() {
			// 	this.$router.push({
			// 		path: 'smart0-intention'
			// 	});
			// },
			scrollToAnchor(event) {
				const href = event.target.getAttribute('href');
				window.location.hash = href;
			},
		}
	}
</script>
<style lang="scss">
	#Smart0 {
		.van-button--round {
			width: 50%;
			height: 32px;
			font-size: 12px
		}
		.btn-wrap {
			position: absolute;
			bottom: 12%;
			width: 100%;
			display: flex;
			justify-content: center;
		}
		.spot-wrap {
			width: 100%;
			height: 100vh;
			color: #595959;
			position: relative;
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			.iframe-image {
				width: 100%;
				height: 100vh;
			}
			.spot-img {
				width: 100%;
			}
		}
		.section-spot {
			.btn-wrap {
				bottom: 8%;
			}
		}
	}
</style>